import * as React from 'react';

export const PictureBox = (props: React.DetailedHTMLProps<React.SVGAttributes<SVGElement>, SVGElement>) => {
  const { ref, ...rest } = props;

  return (
    // tslint:disable:max-line-length
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="128" height="119" viewBox="0 0 128 119">
      <g fill="none" fillRule="evenodd" stroke="#13344B" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
        <path d="M17.96 56.897s-.809 16.53 0 29.399c.557 8.951 17.303 31.33 17.303 31.33"/>
        <path d="M30.406 66.256l4.857 7.172s-2.428 41.35 0 44.199c3.238 3.814 73.512-3.713 73.512-3.713s1.012-29.398 0-42.216c-.101-1.576-3.845-5.086-3.845-5.086M56.765 73.478l-20.793-.05M80.493 73.478l24.437-.712"/>
        <path d="M66.934 29.635s1.164 24.312 0 48.574L11.03 53.947V37.57"/>
        <path d="M66.934 78.209l46.242-15.513s4.048-34.74 0-46.844c0 0-39.31 6.357-46.242 12.715"/>
        <path d="M12.85 10.613S4.25 20.734.456 31.313C-.708 34.519 54.54 53.948 54.54 53.948l12.395-25.38-54.083-17.954zM12.85 10.613L56.31 1l56.866 14.852 14.47 16.428-14.47-2.645M56.31 1v24.058M94.406 41.435v6.155s-.708.254-1.062.254c-.354 0-.405-5.85 0-6.154.405-.306 1.062-.255 1.062-.255zM94.103 38.13c.405 0 .607.711.303 1.322-.354.61-.96.864-1.315.305-.354-.56-.152-1.577 1.012-1.628z"/>
        <path d="M85.502 47.793c-3.34-7.12 2.884-13.122 8.904-14.089 2.631-.407 7.994.458 7.943 6.714-.05 8.952-12.698 16.225-16.847 7.375"/>
      </g>
    </svg>
    // tslint:enable:max-line-length
  );
};
